import React from "react";
import {Autocomplete, TextField} from "@mui/material";
import {forms, objects, strings} from "@atttomyx/shared-utils";

const LabeledDateForm = (props) => {
    const { options, data, onChange : onSync } = props;

    const onChange = (field, value) => {
        const modified = objects.deepCopy(data);

        modified[field] = value;
        modified.valid = strings.isNotBlank(modified.label)
            && strings.isNotBlank(modified.value);

        onSync(modified);
    };

    return <div className="labeled-date-form">
        <div className="field top-margin">
            <Autocomplete
                freeSolo={true}
                options={options}
                inputValue={forms.sanitizeValue(data.label)}
                value={null}
                isOptionEqualToValue={(option, value) => value && strings.equalsIgnoreCase(option, value)}
                renderInput={params =>
                    <TextField
                        required={true}
                        label="Label"
                        {...params}
                    />}
                onInputChange={(event, value, reason) => {
                    if (reason !== "reset") {
                        onChange("label", value);
                    }
                }}
                onChange={(event, value) => onChange("label", value)}
            />
        </div>
        <div className="field">
            <TextField
                required={true}
                label="Date"
                type="date"
                value={forms.sanitizeValue(data.value)}
                onChange={(event) => onChange("value", event.target.value)}
            />
        </div>
    </div>
};

export default LabeledDateForm;
